import { Wall } from "../jsonParse";
import * as THREE from 'three';
import { ThreeView } from "../../view3d/webcad/View3dWebCad";
import { CreateObject } from "../CreateObject";
import { PointInfo } from '../WalltoFittingInfo';

export class WallToPointList {

    constructor(private walls: Wall[], private rad: number, private offsetY: number, private isVisible: boolean = true) {
        ;
    } 

    public execute(): PointInfo[] {
        // 壁のポイントリストを作成
        const pointList =  this.walls.map((wall: Wall) => {

            const transform = wall.transform;
            const m = new THREE.Matrix4();
            m.elements = transform;
            const dimension = wall.dimensions;
            const width = dimension[0];
            // 壁からlineを作成する
            const lineObject = CreateObject.createWallLine(width, m, this.offsetY - dimension[1]/2);
            lineObject.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rad);
            if (this.isVisible) ThreeView.get().wcItemmgr.addOtherShapes(lineObject);

            const euler = lineObject.rotation;
            const points = (lineObject.geometry.attributes.position as THREE.BufferAttribute).array;
            const start = new THREE.Vector3(points[0], points[1], points[2]).applyEuler(euler);
            const end = new THREE.Vector3(points[3], points[4], points[5]).applyEuler(euler);

            return [new PointInfo(start, true), new PointInfo(end, true)];

        }).flat();

        console.log(pointList);

        return pointList;
    }

}